import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onChange", "value", "defaultValue", "name", "isDisabled", "isFocusable", "isNative"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/use-radio-group.ts
import { isObject } from "@chakra-ui/shared-utils";
import { mergeRefs } from "@chakra-ui/react-use-merge-refs";
import { useCallback, useRef, useState, useId } from "react";
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}
function useRadioGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onChangeProp = props.onChange,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    nameProp = props.name,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    isNative = props.isNative,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(defaultValue || ""),
    _useState2 = _slicedToArray(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var isControlled = typeof valueProp !== "undefined";
  var value = isControlled ? valueProp : valueState;
  var ref = useRef(null);
  var focus = useCallback(function () {
    var rootNode = ref.current;
    if (!rootNode) return;
    var query = "input:not(:disabled):checked";
    var firstEnabledAndCheckedInput = rootNode.querySelector(query);
    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }
    query = "input:not(:disabled)";
    var firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  var uuid = useId();
  var fallbackName = "radio-".concat(uuid);
  var name = nameProp || fallbackName;
  var _onChange = useCallback(function (eventOrValue) {
    var nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp == null ? void 0 : onChangeProp(String(nextValue));
  }, [onChangeProp, isControlled]);
  var getRootProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: mergeRefs(forwardedRef, ref),
      role: "radiogroup"
    });
  }, []);
  var getRadioProps = useCallback(function () {
    var _objectSpread2;
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var checkedKey = isNative ? "checked" : "isChecked";
    return _objectSpread(_objectSpread({}, props2), {}, (_objectSpread2 = {
      ref: ref2,
      name: name
    }, _defineProperty(_objectSpread2, checkedKey, value != null ? props2.value === value : void 0), _defineProperty(_objectSpread2, "onChange", function onChange(event) {
      _onChange(event);
    }), _defineProperty(_objectSpread2, "data-radiogroup", true), _objectSpread2));
  }, [isNative, name, _onChange, value]);
  return {
    getRootProps: getRootProps,
    getRadioProps: getRadioProps,
    name: name,
    ref: ref,
    focus: focus,
    setValue: setValue,
    value: value,
    onChange: _onChange,
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    htmlProps: htmlProps
  };
}
export { useRadioGroup };